import 'core-js/stable';
import 'regenerator-runtime/runtime';


import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import './plugins/element.js'
// import './element-variables.scss'
import 'element-ui/lib/theme-chalk/display.css';
import 'vue-croppa/dist/vue-croppa.css'

// Importar vue-trix
import VueTrix from 'vue-trix'
import 'trix/dist/trix.css'


import VueScrollTo from 'vue-scrollto'

import Vue2Filters from 'vue2-filters'
import VueMask from 'v-mask'
import browserDetect from "vue-browser-detect-plugin";
import VueMobileDetection from "vue-mobile-detection";
import Vidle from 'v-idle'
import Croppa from 'vue-croppa'

// import VueDragscroll from "vue-dragscroll";



var Vue2FiltersConfig = {
  capitalize: {
    onlyFirstLetter: true
  },
  number: {
    format: '0',
    thousandsSeparator: '.',
    decimalSeparator: ','
  },
  bytes: {
    decimalDigits: 2
  },
  percent: {
    decimalDigits: 2,
    multiplier: 100,
    decimalSeparator: ','
  },
  currency: {
    symbol: '$',
    decimalDigits: 2,
    thousandsSeparator: '.',
    decimalSeparator: ',',
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: false,
    showPlusSign: false
  },
  pluralize: {
    includeNumber: false
  },
  ordinal: {
    includeNumber: false
  }
}
window.sessionStorage.getItem("operador")
  ? window.sessionStorage.getItem("operador")
  : 0,

Vue.use(Croppa)       
Vue.use(Vue2Filters, Vue2FiltersConfig)
Vue.use(VueMask);
Vue.use(browserDetect);
Vue.use(VueMobileDetection);
Vue.use(Vidle)
Vue.use(VueScrollTo);
Vue.use(VueTrix);
import VueMoment from 'vue-moment'
const moment = require('moment')
require('moment/locale/es')
Vue.config.productionTip = false
Vue.use(VueMoment, {
  moment
})

// Vue.prototype.$isAdmin = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
